import PosthogService from '~/services/posthog/PosthogService';
import { toCandidatePositionProperties, type IConfirmCandidatePositionContext } from './types';

/**
 * Fires when an office clicks the "Confirm" button on the Confirm Candidate page.
 *
 * Note this fires *before* the confirm request is sent, so it counts attempts that
 * later fail (a missing payment card, a server error) as well as shifts that were
 * actually filled.
 *
 * Event: dental_portal:confirm_candidate:confirm_clicked
 */
export function fireConfirmCandidateConfirmClicked(
  payload: IConfirmCandidatePositionContext,
): void {
  PosthogService.getInstance().track(
    'dental_portal:confirm_candidate:confirm_clicked',
    toCandidatePositionProperties(payload),
  );
}
